import { ensureRouteInfiniteData } from '@/app/query-client'
import { marketNewsService } from '@/features/news/api/marketNewsService'
import { newsStoriesQueryOptions } from '@/features/news/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import type { NewsArticlesQuery } from '@/schemas/market-news'
import { marketNewsSearchSchema } from '@/screens/market/news-search'

type MarketNewsSearch = ReturnType<typeof marketNewsSearchSchema.parse>

/** The News list's query for a URL, each unserved group left out at its default. */
export const storiesQueryFor = (search: MarketNewsSearch): NewsArticlesQuery => ({
  sort: search.sort,
  lang: search.lang,
  ...(search.scope === 'all' ? {} : { scope: search.scope }),
  ...(search.query === undefined ? {} : { query: search.query }),
  ...(search.show === 'everything' ? {} : { show: search.show }),
  ...(search.sectors.length === 0 ? {} : { sectors: search.sectors }),
  ...(search.sources.length === 0 ? {} : { sources: search.sources }),
})

/**
 * The `/market/news` loader: nothing while mm-be has no news endpoint
 * (`marketNewsService.available`), then the list's first page for the entry search.
 */
export async function loadMarketNews({
  context: { queryClient },
  location,
}: {
  context: RouterContext
  location: { search: unknown }
}): Promise<void> {
  if (!marketNewsService.available) return
  const search = marketNewsSearchSchema.parse(location.search)
  await ensureRouteInfiniteData(queryClient, newsStoriesQueryOptions(storiesQueryFor(search)))
}
